<div
  *ngIf="!isAdminEncounter"
  class="button button__delete"
  (click)="deleteEncounter($event)">×</div>

  <app-confirmation-modal class="delete-encounter-modal" [(visible)]="isConfirmDeleteVisible" header="WARNING"
    acceptText="CONTINUE" rejectText="CANCEL" (onYes)="deleteEncounterFromServer()">
    Deleting this Encounter will also delete all associated Diagnosis Codes.<br/><br />Are you sure you want to continue?
  </app-confirmation-modal>